<template src="./component.html"></template>

<script>
export default {
  name: "HowWork"
}
</script>

<style src="./component.scss" scoped lang="scss"/>
